import React, {FC} from 'react'
import {RouterProvider} from 'react-router-dom'

import {router} from './routes'

export const Router: FC = () => <RouterProvider router={router} />
